"use server";

import { z } from "zod";
import { headers } from "next/headers";
import { requestPasswordReset, resetPassword } from "@/lib/auth/reset";

const requestSchema = z.object({ email: z.email("Informe um e-mail valido.") });

export type RequestResetState = { sent?: boolean; error?: string };

export async function requestResetAction(
  _prevState: RequestResetState,
  formData: FormData
): Promise<RequestResetState> {
  const parsed = requestSchema.safeParse({ email: formData.get("email") });
  if (!parsed.success) {
    return { error: parsed.error.issues[0]?.message ?? "Dados invalidos." };
  }

  const headersList = await headers();
  const host = headersList.get("host") ?? process.env.DEFAULT_PLATFORM_DOMAIN ?? "localhost:3000";
  const protocol = host.startsWith("localhost") ? "http" : "https";

  await requestPasswordReset(parsed.data.email, `${protocol}://${host}`);

  // Sempre retorna sucesso, mesmo se o e-mail nao existir (evita enumeracao de contas).
  return { sent: true };
}

const resetSchema = z
  .object({
    email: z.email(),
    token: z.string().min(1),
    novaSenha: z.string().min(8, "A senha deve ter pelo menos 8 caracteres."),
    confirmarSenha: z.string().min(1),
  })
  .refine((data) => data.novaSenha === data.confirmarSenha, {
    message: "As senhas nao coincidem.",
    path: ["confirmarSenha"],
  });

export type ResetState = { done?: boolean; error?: string };

export async function resetPasswordAction(
  _prevState: ResetState,
  formData: FormData
): Promise<ResetState> {
  const parsed = resetSchema.safeParse({
    email: formData.get("email"),
    token: formData.get("token"),
    novaSenha: formData.get("novaSenha"),
    confirmarSenha: formData.get("confirmarSenha"),
  });

  if (!parsed.success) {
    return { error: parsed.error.issues[0]?.message ?? "Dados invalidos." };
  }

  const result = await resetPassword(parsed.data.email, parsed.data.token, parsed.data.novaSenha);
  if (!result.ok) {
    return { error: result.error };
  }

  return { done: true };
}
